import { Supervisor, Workspace } from "~/packages/taskrouter";
import type { ClientOptions } from "~/modules/client";
import { SessionOptions } from "~/modules/session";
import type { LoggerOptions } from "~/modules/logger";
import { getDefaultLoggerOptions } from "~/modules/logger/LoggerFactory/defaultLogger";
import { AccountConfigOptions, TelemetryOptions } from "~/modules/config";
import { getDefaultSessionOptions } from "~/modules/session/SessionOptions/defaultSessionOptions";
import { getDefaultAccountConfigOptions } from "~/modules/config/AccountConfigOptions/getDefaultAccountConfigOptions";
import { getDefaultTaskRouterOptions } from "~/packages/taskrouter/getDefaultTaskRouterOptions";
import type { TaskRouterOptions } from "~/packages/taskrouter/TaskRouterOptions";
import type { VoiceOptions } from "~/modules/voice/voiceOptions";
import { getDefaultVoiceOptions } from "~/modules/voice/getDefaultVoiceOptions";
import { getDefaultTelemetryOptions } from "~/modules/config/TelemetryOptions/getDefaultTelemetryOptions";


export class ClientOptionsStore implements ClientOptions {
    readonly #session: SessionOptions;

    readonly #logger: LoggerOptions;

    readonly #accountConfig: AccountConfigOptions;

    
    
    #region: string;

    
    
    #regionNonFlex: string;

    #appName: string;

    #appVersion: string;

    #worker?: Supervisor;

    #workspace?: Workspace;

    #taskRouterOptions: TaskRouterOptions;

    #voiceOptions: VoiceOptions;

    #telemetryOptions: TelemetryOptions;

    constructor() {
        this.#session = getDefaultSessionOptions();
        this.#logger = getDefaultLoggerOptions();
        this.#accountConfig = getDefaultAccountConfigOptions();
        this.#taskRouterOptions = getDefaultTaskRouterOptions();
        this.#voiceOptions = getDefaultVoiceOptions();
        this.#telemetryOptions = getDefaultTelemetryOptions();
    }

    get session(): SessionOptions {
        return this.#session;
    }

    get logger(): LoggerOptions {
        return this.#logger;
    }

    get accountConfig(): AccountConfigOptions {
        return this.#accountConfig;
    }

    get region(): string {
        return this.#region;
    }

    set region(value: string) {
        this.#region = value;
    }

    get regionNonFlex(): string {
        return this.#regionNonFlex;
    }

    set regionNonFlex(value: string) {
        this.#regionNonFlex = value;
    }

    get appName(): string {
        return this.#appName;
    }

    set appName(value: string) {
        this.#appName = value;
    }

    get appVersion(): string {
        return this.#appVersion;
    }

    set appVersion(value: string) {
        this.#appVersion = value;
    }

    get workspace(): Workspace | undefined {
        return this.#workspace;
    }

    set workspace(value: Workspace | undefined) {
        this.#workspace = value;
    }

    get worker(): Supervisor | undefined {
        return this.#worker;
    }

    set worker(value: Supervisor | undefined) {
        this.#worker = value;
    }

    get taskRouterOptions(): TaskRouterOptions {
        return this.#taskRouterOptions;
    }

    set taskRouterOptions(value: TaskRouterOptions) {
        this.#taskRouterOptions = value;
    }

    get voiceOptions(): VoiceOptions {
        return this.#voiceOptions;
    }

    set voiceOptions(value: VoiceOptions) {
        this.#voiceOptions = value;
    }

    get telemetryOptions(): TelemetryOptions {
        return this.#telemetryOptions;
    }

    set telemetryOptions(value: TelemetryOptions) {
        this.#telemetryOptions = value;
    }
}

let instance: ClientOptionsStore;
export const getClientOptionsStoreInstance: () => ClientOptionsStore = () => {
    instance = instance || new ClientOptionsStore();
    return instance;
};
